import { useMutation, useQuery } from "react-query";
import afterLoginApiAxios from "../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../Util/Helper/localStorageUtils";

const fetchCoupons = () => {
  return afterLoginApiAxios({
    method: "post",
    url: "/doctor/reward-coupons",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
    data: {
      "authorizer-principal-id": {
        user_type: "1",
      },
      doctor_id: localStorage.getItem(LOCALSTORAGEKEY.USER_ID),
    },
  }).then((res) => res.data);
};

const fetchCareGroup = () => {
  return afterLoginApiAxios({
    method: "post",
    url: "/doctor/get-care-group",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
    data: {
      "authorizer-principal-id": {
        user_type: "1",
      },
      doctor_id: localStorage.getItem(LOCALSTORAGEKEY.USER_ID),
      appointment_date: "",
    },
  }).then((res) => res.data);
};

export const shareCoupon = (payload, selectedCoupon) => {
  const parsedPayload = payload.patient_info
    .map((item) => JSON.parse(item))
    .map((row, index) => ({
      email_id: row.email,
      patient_name: row.patient_name,
      phone_no: row.patient_number,
      coupon_id: selectedCoupon.id[index],
    }));
  return afterLoginApiAxios({
    method: "post",
    url: "/doctor/share-reward-coupons",
    headers: {
      Authorization: localStorage.getItem("id_token"),
    },
    data: {
      "authorizer-principal-id": {
        user_type: "1",
      },
      doctor_id: localStorage.getItem(LOCALSTORAGEKEY.USER_ID),
      patient_info: parsedPayload,
    },
  });
};

const useCoupons = () => {
  return useQuery("fetchCoupons", () => fetchCoupons(), {
    refetchOnWindowFocus: false,
  });
};

const useCareGroup = () => {
  return useQuery(["fetchCareGroup"], () => fetchCareGroup(), {
    refetchOnWindowFocus: false,
  });
};
const useShareCoupon = () => {
  return useMutation([], ({ payload, selectedCoupon }) =>
    shareCoupon(payload, selectedCoupon)
  );
};

export { useCoupons, useCareGroup, useShareCoupon };
